import type { ServerResponse } from "@/http"
import type { IEventTemplateResponse } from "@/types"
import { axios } from "@/axios"
import { EventTemplate } from "@/models"

export async function listEventTemplates(eventVaultId?: number) {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to get event templates. Please ensure `eventVaultId` is provided.",
    )
  }

  const { data } = await axios.get<ServerResponse<IEventTemplateResponse[]>>(`api/template?eventVaultid=${eventVaultId}`)

  return data.Data?.map(template => EventTemplate.fromResponse(template))
}
